<template>
  <div class="userset-info">
    <div class="content">
      <el-form :model="form" :rules="rules" ref="form" label-position="top" style="width: 600px">
        <el-form-item :label="$t('base_userset_date.mo_ren_shi_qu')">
          <custom-select v-model="form.timeZoneId" url="timeZoneGetCompanyList" width="100%" :props="{ label: 'timeZoneRegionDesc', value: 'timeZoneId' }"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('base_userset_date.rqxsgs')">
          <custom-select v-model="form.dateFormat" code="bas_date_format" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('base_userset_date.24xiao_shi_zhi')">
          <custom-select v-model="form.isTime24h" code="isynergy_cloud_bool" width="100%"></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn-group">
      <el-button @click="updateDate" type="primary">{{ $t('Common.com_save') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  data() {
    return {
      userId: '',
      orgId: '',
      form: {
        timeZoneId: '',
        dateFormat: '',
        isTime24h: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        timeZoneId: {
          required: true,
          message: this.$t('base_userset_date.qxzmrsq'),
        },
        dateFormat: {
          required: true,
          message: this.$t('base_userset_date.qxzrqgs'),
        },
      };
    },
  },
  mounted() {
    this.userInfo = this.$store.state.userInfo;
    this.userId = this.userInfo.userId;
    this.orgId = this.userInfo.rootOrgId;
    this.getUserDate();
  },
  methods: {
    // 获取用户信息
    getUserDate: function () {
      if (!this.userId) {
        return;
      }
      this.$getJSON(`${apis.User}/${this.userId}`).then((res) => {
        this.$setFormatData(this.form, res.data);
      });
    },
    // 更新用户信息
    updateDate: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(apis.UserUpdate, {
          orgId: this.orgId,
          userId: this.userId,
          timeZoneId: this.form.timeZoneId,
          dateFormat: this.form.dateFormat,
          isTime24h: this.form.isTime24h,
        }).then(() => {
          this.$store.commit('TIMEZONEID', this.form.timeZoneId);
          this.$store.commit('DATEFORMAT', this.form.dateFormat);
          this.$store.commit('ISTIME24H', this.form.isTime24h || true);
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
        });
      });
    },
  },
};
</script>

<style lang="scss"></style>
